import "./SortControl.scss";
import OpSelect from "../OpSelect/OpSelect";

export function SortControl({
	updateSort,
	sort,
	sortOptions = [],
	modalOpen,
	delay = 0.5,
	duration = 2,
}) {
	return (
		<div
			className="sort-control"
			style={{ "--delay": `${delay}s`, "--duration": `${duration}s` }}>
			<div
				className={`sort-control__inner ${
					modalOpen ? "sort-control__inner--modal-open" : ""
				}`}>
				<OpSelect
					options={sortOptions}
					selected={sort}
					handleChange={(prev, current) => {
						updateSort(current);
					}}
					getValue={(o) => o.key}
					getLabel={(o) => o.label}
					useIconMobile={true}
				/>
			</div>
		</div>
	);
}
